import React, { ComponentType } from 'react';
import styles from './ChannelsPanel.scss';
import classNames from 'classnames';
import { ChannelType } from '@wix/ambassador-chat-channels-v1-channel/types';
import { useColors, useDesign } from '../../hooks/editor-settings';
import { getIconComponent, isIcon } from '../MinimizedChat/icons';
import { ChatIcons } from '@wix/inbox-common';

export interface ChannelTab {
  name: string;
  type: ChannelType;
  icon: JSX.Element;
  selectedIcon: JSX.Element;
  component?: ComponentType<any>;
}

export interface ChannelsPanelProps {
  channels: ChannelTab[];
  onSelectedChannel(type: ChannelType): void;
  selectedChannel: ChannelType;
  thumbnail: string | undefined;
}

export const ChannelsPanel: React.FunctionComponent<ChannelsPanelProps> = ({
  channels,
  onSelectedChannel,
  selectedChannel,
  thumbnail,
}) => {
  const { channelsColor } = useColors();
  const design = useDesign();
  const chatChannelIconSize = '16px';
  const isChatChannel = (channelType: ChannelType) =>
    channelType === ChannelType.UNDEFINED;
  const isChatSelected = selectedChannel === ChannelType.UNDEFINED;

  const borderRadiusForLegacyIcons = thumbnail?.startsWith('legacy-')
    ? '50%'
    : '0';
  const channelThumbnail =
    thumbnail && isIcon(thumbnail) ? thumbnail : ChatIcons.CircleFilled;

  const thumbnailComponent = getIconComponent(
    channelThumbnail,
    channelsColor.value,
    chatChannelIconSize,
    borderRadiusForLegacyIcons,
  );

  return (
    <div
      className={styles.channelsPanel}
      style={{ borderRadius: `${design.selectedRadiusOption}px` }}
      data-hook="channels-panel"
    >
      {Object.values(channels).map((channel) => (
        <button
          data-hook={`channel-${channel.type}`}
          aria-label={`channel-${channel.name}`}
          key={channel.type}
          className={classNames(styles.channel, {
            [styles.selected]: selectedChannel === channel.type,
          })}
          style={{ borderRadius: `${design.selectedRadiusOption}px` }}
          onClick={() => onSelectedChannel(channel.type)}
        >
          {isChatChannel(channel.type) ? (
            <span
              style={{
                color: isChatSelected ? channelsColor.value : '#000000',
                height: chatChannelIconSize,
              }}
            >
              {thumbnailComponent}
            </span>
          ) : selectedChannel === channel.type ? (
            channel.selectedIcon
          ) : (
            channel.icon
          )}
        </button>
      ))}
    </div>
  );
};
